export default __webpack_public_path__ + "static/Gatekeeper_cropped-cfd350fcae2249652c92b8177ae8435e.jpg";